<template>
  <div class="content">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 搜索条件 -->
    <div class="serchTerms">
      <div class="input_box">
        <span>考生姓名：</span>
        <el-input
          v-model.trim="examName"
          placeholder="请输入考生姓名"
          style="width: 200px"
        ></el-input>
      </div>
      <div class="input_account">
        <span>考生账号：</span>
        <el-input
          v-model.trim="studentName"
          placeholder="请输入考生账号"
          style="width: 200px"
        ></el-input>
      </div>
      <div class="select_box">
        <span>科室：</span>
        <el-select
          v-model="department"
          placeholder="全部"
          class="hosname"
          @change="handleQuery($event, 'isState')"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in options_ks"
            :key="item.DepartmentID"
            :label="item.DepartmentName"
            :value="item.DepartmentName"
            style="width: 200px"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select_box">
        <span>职称：</span>
        <el-select
          v-model="job"
          placeholder="全部"
          class="hosname"
          @change="handleQuery($event, 'isState')"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in options_zc"
            :key="item.pTitleID"
            :label="item.PTitle"
            :value="item.PTitle"
            style="width: 200px"
          >
          </el-option>
        </el-select>
      </div>
      <el-button
        @click="handleQuery"
        type="primary"
        icon="el-icon-search"
        class="searchbtn"
        >搜索</el-button
      >
      <el-button
        @click="resetQuery"
        icon="el-icon-refresh"
        class="searchbtn resetBtn"
        >重置</el-button
      >
    </div>
    <!-- 操作按钮 -->
    <div class="flex_">
      <div class="operaBtn">
        <el-button @click="addExaminee()" plain>
          <i class="iconfont icon-action-add-hover"></i>添加考生
        </el-button>
        <el-button :disabled="multiple" @click="bulkImportBtn()">
          <i class="el-icon-remove-outline"></i>批量移除
        </el-button>
        <el-button @click="importCandidate" plain>
          <i class="iconfont icon-action-add-hover"></i>批量导入考生
        </el-button>
      </div>
      <div class="qr_view">
        <i
          class="isselectico iconfont icon-ico"
          @click.stop="openqrwindows"
          v-if="qrValue == true"
        ></i>
        <p v-if="qrValue == true">是否开启扫码进组</p>
        <el-switch v-model="qrValue" @change="scanQrChange"> </el-switch>
      </div>
    </div>

    <!-- 表格内容 -->
    <div class="kaoshengTable">
      <el-table
        ref="table"
        :data="getMemberData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @row-click="StepsListRowClick"
        @selection-change="handleSelectionChange"
        v-loading="isLoading"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
        ></el-table-column>

        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
          <template slot-scope="scope">
            <p v-if="index == 0">{{ scope.row.UserName }}</p>
            <p v-if="index == 1">{{ scope.row.RealName }}</p>
            <p v-if="index == 2">{{ scope.row.DepartmentName }}</p>
            <p v-if="index == 3">{{ scope.row.PTitle }}</p>
            <p v-if="index == 4">{{ scope.row.Position }}</p>
            <p v-if="index == 5">
              {{
                scope.row.Birthday == null
                  ? null
                  : $moment(scope.row.Birthday).format("YYYY-MM-DD")
              }}
            </p>
            <p v-if="index == 6">{{ scope.row.JobDate }}</p>
          </template>
        </el-table-column>

        <el-table-column prop="address" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                @click.stop="examDelete(scope.row)"
                >移除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="footBox">
      <div class="footPage">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="removeDialog">
      <el-dialog :title="typeTitle" :visible.sync="dialogRemoveVisible">
        <span>{{ content }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogRemoveVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSure()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 考生组--添加考生 -->
    <div class="addExam">
      <add-exam :exam-ID="examID" :key="timer" ref="examChild"></add-exam>
    </div>
    <!-- 二维码下载弹窗 -->
    <div class="qrcodeView">
      <el-dialog
        title="考生组二维码"
        :visible.sync="qrdialogVisible"
        width="18%"
        :close-on-click-modal="false"
      >
        <p class="qr_p">{{ $parent.rowObj.groupName }}</p>
        <vueqr
          :bgSrc="config.logo"
          :logoSrc="config.imagePath"
          :text="config.value"
          :size="300"
          ref="isAn"
        ></vueqr>
        <el-button type="text" size="small" @click="download" class="mr24"
          >下载二维码</el-button
        >
        <p class="red_p"><span>注:</span> 当前二维码只支持医考拉扫码！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="qrdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qrdialogVisible = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- canvas生成的图片 -->
    <div v-if="qrdialogVisible" ref="codeDownLoad" class="qrcodeView downLoad">
      <p class="qr_p">{{ $parent.rowObj.groupName }}</p>
      <vueqr
        :bgSrc="config.logo"
        :logoSrc="config.imagePath"
        :text="config.value"
        :size="300"
      ></vueqr>
      <p class="red_p"><span>注:</span> 当前二维码只支持医考拉扫码！</p>
    </div>
    <div v-if="qrdialogVisible">
      <img ref="saveImage" src="" alt="" />
    </div>
    <!-- 批量导入考生 -->
     <ImportUser ref="userImport" :groupID="this.$parent.rowObj.groupID" />
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js";
import ImportUser from "./ImportUser.vue";
import {
  groupStudentList,
  getSectionList,
  getPTitleList,
  deleteStudent,
  groupUpdateScan,
} from "@/services/examManager.js";
import AddExam from "./addExam.vue";
import vueqr from "vue-qr";
import html2canvas from "html2canvas";

export default {
  name: "memberManage",
  props: ["changes"],
  components: {
    AddExam,
    vueqr,
    ImportUser
  },
  data() {
    return {
      qrdialogVisible: false, //二维码扫描的弹窗
      examID: "",
      timer: "",
      // 考生姓名
      examName: "",
      // 考生账号
      studentName: "",
      // 科室
      department: "",
      // 职称
      job: "",
      // 成员列表请求数据
      memberListPara: new Object(),
      // 成员列表数据
      getMemberData: [],
      // 弹框状态
      dialogRemoveVisible: false,
      // 弹框头部文字
      typeTitle: "",
      // 弹框内容
      content: "",
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      // 总数量
      total: 100,
      isLoading: false,
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      multipleSelection: [], // 当前页选中的数据
      changePageCoreRecordDataStats: true,
      idKey: "UserID",
      config: {
        //二维码内的信息
        value: "", //显示的值、跳转的地址
        imagePath: require("@/assets/yunlogo.png"), //中间logo的地址
      },
      formColumns: [
        {
          prop: "UserName",
          label: "考生账号",
        },
        {
          prop: "RealName",
          label: "考生姓名",
        },
        {
          prop: "DepartmentName",
          label: "科室",
        },
        {
          prop: "PTitle",
          label: "职称",
        },
        {
          prop: "Position",
          label: "职位",
        },
        {
          prop: "Birthday",
          label: "出生年月",
        },
        {
          prop: "JobDate",
          label: "工作年限",
        },
      ],
      // 科室
      options_ks: [],
      // 职称
      options_zc: [],
      // 当前页
      currentPage: 1,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      qrValue: false, // 二维码状态
    };
  },
  methods: {
    // 搜索
    handleQuery(item, res) {
      if (res === "isState") {
        this.memberListPara.department = "";
        this.memberListPara.job = "";
      }
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      this.changePageCoreRecordDataStats = true;
      // 初始化查询接口请求参数
      this.currentPage = 1;
      // 查询条件
      //memberListPara.searchStr = "";
      if (this.examName) {
        this.memberListPara.examName = this.examName;
      } else {
        this.memberListPara.examName = "";
      }
      if (this.studentName) {
        this.memberListPara.studentName = this.studentName;
      } else {
        this.memberListPara.studentName = "";
      }
      if (this.department) {
        this.memberListPara.department = this.department;
      } else {
        this.memberListPara.department = "";
      }
      if (this.job) {
        this.memberListPara.job = this.job;
      } else {
        this.memberListPara.job = "";
      }
      this.memberManageListData();
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 重置
    resetQuery() {
      // 初始化条件筛选框
      this.examName = "";
      this.studentName = "";
      this.department = "";
      this.job = "";
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      this.changePageCoreRecordDataStats = true;
      // 初始化查询接口请求参数
      this.currentPage = 1;
      this.memberListPara.examName = "";
      this.memberListPara.studentName = "";
      this.memberListPara.department = "";
      this.memberListPara.job = "";
      this.memberManageListData();
    },
    // 批量导入
    importCandidate(){
      this.$refs.userImport.dialogBoxVisible = true
    },
    // 确定
    async handleSure() {
      const reqParam = new Object();
      this.UtilFun(reqParam);
      reqParam.groupID = this.$parent.$children[0].rowData.groupID;
      switch (this.status) {
        case 0:
          reqParam.deleteUserIDArr = `[${this.rowData.UserID}]`;
          break;
        case 1:
          reqParam.deleteUserIDArr = `[${this.getAllSelectionUserID()}]`;
          break;
        default:
          break;
      }
      const { data } = await deleteStudent(reqParam);
      if (data.Status == 200) {
        this.$message.success("考生移出成功");
        this.dialogRemoveVisible = false;
        this.memberManageListData();
        this.$refs.examChild.getStudentList();
      } else {
        this.$message.error(data.Data);
      }
    },

    backBtn() {
      this.$parent.changes(0);
    },
    // handlePageData() {
    //   this.getMemberData = this.getMemberData.map((item) => {
    //     item.Birthday1 = this.$moment(item.Birthday).format("YYYY-MM-DD hh:mm");
    //     return item;
    //   });
    // },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },

    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.getMemberData.length; i++) {
        if (selectAllIds.indexOf(this.getMemberData[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.getMemberData[i], true);
        }
      }
    },

    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach((row) => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.getMemberData.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },

    // 得到选中的所有数据
    getAllSelectionData() {
      // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
      this.changePageCoreRecordData();
      return this.multipleSelectionAll;
    },

    // 得到选中的所有数据的id
    getAllSelectionUserID() {
      let data = this.getAllSelectionData();
      let userIDs = [];
      data.forEach((element) => {
        userIDs.push(element.UserID);
      });
      return userIDs;
    },

    // 显示条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.changePageCoreRecordData();
      this.pageSize = val;
      this.memberManageListData();
    },

    // 分页
    handleCurrentChange(val) {
      this.changePageCoreRecordData();
      this.currentPage = val;
      this.changePageCoreRecordDataStats = false;
      this.memberManageListData();
      // this.handlePageData();
    },

    // 上一页
    handlePrevClick() {
      this.memberManageListData();
    },
    // 点击下一页
    handleNextClick() {
      this.memberManageListData();
      // this.getMemberData = this.pageData(2, 10, this.memberData);
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      if (this.changePageCoreRecordDataStats) {
        this.changePageCoreRecordData();
      }
      this.multiple = !this.multipleSelectionAll.length;
      // this.ids = selection.map((item) => item.groupID);
      // this.multiple = !selection.length;
      // this.single = selection.length != 1;
    },

    // 移除分组
    bulkImportBtn() {
      this.status = 1;
      this.typeTitle = "温馨提示";
      this.dialogRemoveVisible = true;
      this.content = "是否将所选考生移出该组？";
    },
    // 移除
    examDelete(row) {
      this.status = 0;
      this.typeTitle = "温馨提示";
      this.rowData = row;
      this.dialogRemoveVisible = true;
      this.content = "是否将该考生移出该组？";
    },
    // 添加考生
    addExaminee() {
      this.$refs.examChild.getDialogVisibleObj(true);
    },
    // 科室下拉框数据
    async getSectionData() {
      const sectionObj = new Object();
      sectionObj.userID = parseInt(this.$store.state.userID);
      sectionObj.guid = this.$store.state.user;
      sectionObj.hid = parseInt(this.$store.state.hid);
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        this.options_ks = data.Data;
      }
    },
    // 职称下拉框数据
    async getPTitleData() {
      const sectionObj = new Object();
      sectionObj.userID = parseInt(this.$store.state.userID);
      sectionObj.guid = this.$store.state.user;
      sectionObj.hid = parseInt(this.$store.state.hid);
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        this.options_zc = data.Data;
        this.options_zc = this.options_zc.forEach((element, index) => {
          element.pTitleID = index;
        });
        this.options_zc = data.Data;
      }
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 成员管理列表数据
    async memberManageListData() {
      this.isLoading = true;
      const memberListPara = this.memberListPara;
      this.UtilFun(memberListPara);
      // 分组ID
      memberListPara.groupID = this.$parent.$children[0].rowData.groupID;
      memberListPara.pageIndex = this.currentPage - 1;
      memberListPara.eachPageNum = this.pageSize;
      const { data } = await groupStudentList(memberListPara);
      if (data.Status === 200) {
        const memberArr = data.Data[0] || [];
        this.getMemberData = memberArr;
        this.total = data.Data[1][0].dataCount;
        setTimeout(() => {
          this.changePageCoreRecordDataStats = true;
          this.setSelectRow();
          this.isLoading = false;
        }, 200);
      } else {
        this.$message.error(data.Data);
      }
    },
    // 下载二维码
    download() {
      let qrcodeImg = this.$refs.saveImage.src;
      let image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      let that = this;
      image.onload = function () {
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = that.projectName || "myImage";
        a.href = qrcodeImg;
        a.dispatchEvent(event);
      };
      image.src = qrcodeImg;
    },
    // 打开二维码
    openqrwindows() {
      this.qrdialogVisible = true;
      let parmars = {
        value: "5", // 考生组 1考试 2练习 3线下培训 4 签到 5 考生组
        groupID: this.$parent.rowObj.groupID,
        groupName: this.$parent.rowObj.groupName,
      };
      this.config.value = JSON.stringify(parmars);
      //生成图片
      setTimeout(() => {
        const canvasIns = html2canvas(this.$refs.codeDownLoad, {
          backgroundColor: "#fff",
          useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
          logging: true,
          scale: 2,
        }).then(
          (canvas) => {
            const url = canvas.toDataURL("image/png", 1.0);
            this.$refs.saveImage.setAttribute("src", url);
          },
          (err) => {}
        );
      }, 500);
    },
    // 扫码进组
    scanQrChange() {
      const type = this.$parent.rowObj.enableScan;
      this.$confirm(
        `此操作将${type == true ? "关闭" : "开启"}, 是否继续?`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const obj = {
            groupID: this.$parent.rowObj.groupID,
            userID: this.$store.state.userID,
            guid: this.$store.state.user,
            enableScan: type == true ? "0" : "1",
          };
          const { data } = await groupUpdateScan(obj);
          if (data.Status == 200) {
            this.$parent.rowObj.enableScan = obj.enableScan;
            this.$message({
              type: "success",
              message: `${type == true ? "关闭" : "开启"}成功!`,
            });
          } else {
            this.$message.error(data.Data);
          }
        })
        .catch(() => {
          this.qrValue = !this.qrValue;
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },

  created() {
    // 给 bus 注册事件，并接收数据
    // eventBus.$on("memberListChanges", (arrData) => {
    //   this.getMemberData = arrData;
    //   this.total = this.getMemberData.length;
    //   this.handlePageData();
    // });
    this.qrValue = this.$parent.rowObj.enableScan == 1 ? true : false;
    this.getSectionData();
    this.getPTitleData();
  },

  activated() {
    this.memberManageListData();
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  padding: 0px 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

.back {
  border-bottom: 1px solid #f8f8f8;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

.serchTerms {
  height: 81px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  margin-right: 170px;
  span {
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    margin-right: 5px;
  }
  .searchbtn {
    margin-left: 25px;
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
  }
  .resetBtn {
    background: #ffffff;
    border: 1px solid #d9d9d9;
  }
}

.operaBtn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 849px;
  height: 40px;
  opacity: 1;
  .el-button + .el-button {
    margin-left: 24px;
  }
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 141px;
  }
  .el-button:nth-child(3) {
    background: #1890ff;
    width: 140px;
  }
}

// 分页
.footBox {
  position: relative;
  height: 110px;
  .footPage {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;

    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

// 表格内容
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #8fcbff;
  color: #333333;
  opacity: 1;
}

.kaoshengTable {
  .el-button {
    font-size: 16px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

::v-deep .removeDialog .el-dialog {
  width: 308px;
  height: 211px;
  border-radius: 5px 5px 5px 5px;
}

::v-deep .dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button {
    margin-right: 30px;
    &:nth-child(1) {
      background: #eeeeee;
      opacity: 1;
      border-radius: 4px;
    }
    &:nth-child(2) {
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
    }
  }
}

// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.isselectico {
  color: #1890ff;
  cursor: pointer;
  font-size: 20px;
}
.flex_ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.qr_view {
  display: flex;
  align-items: center;
  margin-right: 24px;
  p {
    margin-right: 16px;
    margin-left: 6px;
  }
}
.qrcodeView {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    min-width: 342px !important;
    // min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      &:nth-child(2) {
        margin-left: 24px;
      }
    }
  }
  .qr_p {
    color: #e54d4d;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
  .exam_p {
    font-size: 14px;
    margin-left: 24px;
    margin-top: 2px;
  }
  .red_p {
    color: #333333;

    span {
      color: #e54d4d;
      font-size: 16px;
    }
  }
}
.mr24 {
  margin-left: 110px;
  font-size: 16px;
}
.downLoad {
  width: 300px;
  height: 450px;
  background-color: #fff;
  margin-top: 800px;
  .exam_p {
    font-size: 10px;
    margin-left: 30px;
    margin-top: 3px;
  }
  .red_p {
    color: #333333;
    padding-left: 20px;
    font-size: 12px;
    span {
      color: #e54d4d;
      font-size: 12px;
    }
  }
}
</style>
